/**
 * Regímenes tributarios de las empresas (columna company.regimen_tributario)
 *
 * Única lista de regímenes de TAXI. La usan el servidor (para validar al crear o
 * editar una empresa y una declaración jurada) y la pantalla (para la lista
 * desplegable y las etiquetas). Al agregar un régimen se suma aquí y en el CHECK de
 * la migración 037.
 *
 * djNoAplican: declaraciones juradas que no se ofrecen ni se aceptan en ese régimen.
 * La 14 D N°8 presenta la DJ 1947 en vez de la 1948, y la 14 D N°3 la 1948 y no la 1947
 * (SII, Principales Declaraciones Juradas por Régimen Tributario).
 */

const REGIMENES_TRIBUTARIOS = [
    { codigo: '14d3', nombre: 'Pro Pyme General (14 D N°3)', djNoAplican: ['DJ1947'] },
    { codigo: '14d8', nombre: 'Pro Pyme Transparente (14 D N°8)', djNoAplican: ['F1948'] },
];

const buscar = (codigo) => REGIMENES_TRIBUTARIOS.find((regimen) => regimen.codigo === codigo) || null;

const esRegimenValido = (codigo) => buscar(codigo) !== null;

/**
 * Claves de los módulos de renta (registros de F22 en pantalla y servidor). Las empresas
 * de empresario individual (company.empresario_individual) usan sus propios módulos, con
 * la clave del régimen precedida de «ei_»: 'ei_14d3', 'ei_14d8'.
 */
const PREFIJO_EMPRESARIO_INDIVIDUAL = 'ei_';

const claveModuloRenta = (regimen, empresarioIndividual) => (empresarioIndividual ? `${PREFIJO_EMPRESARIO_INDIVIDUAL}${regimen}` : regimen);

const esClaveEmpresarioIndividual = (clave) => String(clave).startsWith(PREFIJO_EMPRESARIO_INDIVIDUAL);

// Nombre para mostrar de un régimen o de una clave de módulo de renta; sin régimen
// conocido, el código tal cual
const nombreRegimen = (codigo) => {
    if (esClaveEmpresarioIndividual(codigo)) {
        const regimen = String(codigo).slice(PREFIJO_EMPRESARIO_INDIVIDUAL.length);
        return `${buscar(regimen)?.nombre ?? regimen} · empresario individual`;
    }
    return buscar(codigo)?.nombre ?? codigo;
};

// ¿Corresponde esta declaración jurada al régimen de la empresa?
const djAplica = (codigo, tipoDj) => !(buscar(codigo)?.djNoAplican ?? []).includes(tipoDj);

module.exports = { REGIMENES_TRIBUTARIOS, esRegimenValido, nombreRegimen, djAplica, claveModuloRenta, esClaveEmpresarioIndividual };
